import { render, staticRenderFns } from "./btn-open-setting.mpx?vue&type=template&id=1d4cec6a&isComponent&outputPath=components%2Fbtn-open-setting70a35574%2Findex"
import script from "./btn-open-setting.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-open-setting70a35574%2Findex"
export * from "./btn-open-setting.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbtn-open-setting70a35574%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports